<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'

const coursesStore: Record<string, any> = useCoursesStore()
const courseDetail = computed(() => coursesStore.state.courseDetail)
</script>

<template>
  <LazyOrganismsNavbar />
  <main id="kursus-detail" class="kg-content">
    <div
      v-if="courseDetail?.isLoading"
      class="absolute top-1/2 left-1/2 translate-x-1/2 translate-y-1/2"
    >
      <a-spin size="large" />
    </div>
    <LazyModulesKursusDetailOrganismsWrapper v-else />
  </main>
  <LazyOrganismsFooter />
</template>

<style lang="scss">
@use './styles.scss';
</style>
